import { ApiResponseData, api } from '~shared/api';

import { routes } from './routes';
import { ApiParentNotificationHistoryResponse } from './types';

export const getParentNotificationHistory = async (
  page = 1,
  limit = 20
): Promise<ApiParentNotificationHistoryResponse | null> => {
  try {
    const response = await api.get<any, ApiResponseData<ApiParentNotificationHistoryResponse>>(
      routes.list(page, limit)
    );

    if ((response as any)?.error) {
      return null;
    }

    return (response as any)?.data ?? null;
  } catch {
    return null;
  }
};

export const getParentNotificationUnreadCount = async (): Promise<number> => {
  try {
    const response = await api.get<any, ApiResponseData<{ count: number }>>(routes.unreadCount());

    if ((response as any)?.error) {
      return 0;
    }

    return (response as any)?.data?.count ?? 0;
  } catch {
    return 0;
  }
};
